<script>
export default {
  name: "driverChannelData",
  data() {
    return {
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/organizationChannel/statistics",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
          ...this.$route.query
        },
        search: [
          {type: "input", field: "name", name: "司机姓名", value: ""},
          {type: "input", field: "phone", name: "手机号", value: ""},
          {type: "input", field: "idCard", name: "身份证号", value: ""},
          {
            type: "select",
            field: "applyStatus",
            name: "认证状态",
            value: "",
            option: this.$const.CHANNELAPPLYSTATUS
          },
        ],
      },
      // 表头
      columns: [
        {prop: "name", label: "司机姓名",},
        {prop: "phone", label: "手机号",},
        {prop: "idCard", label: "身份证号",},
        {prop: "created", label: "注册时间",},
        {prop: "lastLoginTime", label: "最后登录时间",},
        {prop: "applyStatus", label: "账号认证状态",},
      ],
    }

  }

}
</script>

<template>
  <div>
    <custom-table :has-organization="false" ref="customTable"
                  :customOptions="customOptions" :columns="columns"
                  labelWidth="135" style="height: 100%">
      <template slot-scope="{ item, row }">
        <template v-if="item.prop == 'created'">{{ row.created | filterTime }}</template>
        <template
            v-else-if="['lastLoginTime','latestDepartureTime','created','finishTime'].includes(item.prop)">
          {{ row[item.prop] | filterTime }}
        </template>
        <template v-else-if="item.prop === 'applyStatus'">
          <span>{{ row[item.prop] | filterConst('CHANNELAPPLYSTATUS') }}</span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

  </div>
</template>

<style scoped lang="less">

</style>